export default __webpack_public_path__ + "static/right-answer-1e206cf1900ce7d20b6debdc02c20838.svg";